import { render } from "./CustomQuillEditor.vue?vue&type=template&id=02fe3dca"
import script from "./CustomQuillEditor.vue?vue&type=script&lang=js"
export * from "./CustomQuillEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__